<template>
    <meta-data page="pro-independent" />
    <Header
        logo="/storage/assets/logos/rectangle_noir.png"
        banner="/storage/assets/images/banners/b2b.jpg"
        connectionIsVisible
        contactIsVisible
    />
    <div class="container">
        <h1>{{ $translate('public.pro.independent.title') }}</h1>
        <p>
            {{ $translate('public.pro.independent.text') }}
        </p>
        <div class="card-container">
            <div class="card">
                <div class="card-header">
                    <img
                        src="/storage/assets/icons/activitePhysique.png"
                        alt="Icon employeur - Leasing de vélos pour entreprises"
                        class="bg-white rounded-full"
                    />
                    <h3>
                        {{ $translate('public.pro.independent.card.1.title') }}
                    </h3>
                </div>
                <div class="card-body">
                    <p>
                        {{ $translate('public.pro.independent.card.1.text') }}
                    </p>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <img
                        src="/storage/assets/icons/pro_all_in.png"
                        alt="Icon employé - Leasing de vélos pour entreprises"
                        class="bg-white rounded-full"
                    />
                    <h3>
                        {{ $translate('public.pro.independent.card.2.title') }}
                    </h3>
                </div>
                <div class="card-body">
                    <p>
                        {{ $translate('public.pro.independent.card.2.text') }}
                    </p>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <img
                        src="/storage/assets/icons/financement.png"
                        alt="Icon indépendant - Leasing de vélos pour entreprises"
                        class="bg-white rounded-full"
                    />
                    <h3>
                        {{ $translate('public.pro.independent.card.3.title') }}
                    </h3>
                </div>
                <div class="card-body">
                    <p>
                        {{ $translate('public.pro.independent.card.3.text') }}
                    </p>
                </div>
            </div>
        </div>
        <div class="how">
            <img
                src="/storage/assets/images/pro-independant.jpg"
                alt="Image indépendant"
            />
            <div class="info">
                <div class="first">
                    <i class="fas fa-1"></i>
                    <p>
                        {{ $translate('public.pro.independent.how.list.1') }}
                    </p>
                </div>
                <div class="second">
                    <i class="fas fa-2"></i>
                    <p>
                        {{ $translate('public.pro.independent.how.list.2') }}
                    </p>
                </div>
                <div class="third">
                    <i class="fas fa-3"></i>
                    <p>
                        {{ $translate('public.pro.independent.how.list.3') }}
                    </p>
                </div>
                <div class="fourth">
                    <i class="fas fa-4"></i>
                    <p>
                        {{ $translate('public.pro.independent.how.list.4') }}
                    </p>
                </div>
                <primary-button
                    color="green"
                    class="w-fit"
                    @click="$router.push({ name: 'contact' })"
                    >{{
                        $translate('public.pro.independent.how.button')
                    }}</primary-button
                >
            </div>
        </div>
    </div>
    <Footer />
</template>
<script setup>
import Footer from '@/js/components/public/Footer.vue';
import Header from '@/js/components/public/Header.vue';
</script>
<style lang="scss" scoped>
@use '@/scss/variables' as vars;
.container {
    margin-top: 2rem;
    .card-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .card {
            width: 30%;
            margin-bottom: 2rem;
            border-radius: vars.$borderRadius;
            box-shadow: vars.$defaultShadow;
            .card-header {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                background-color: vars.$greenColor;
                img {
                    max-width: 50px;
                    margin-right: 0.5rem;
                }
                h3 {
                    font-size: vars.$primaryFontSize;
                    font-weight: 700;
                    margin: 0;
                    color: vars.$whiteColor;
                }
            }
            .card-body {
                padding: 1rem;
                p {
                    font-size: 1rem;
                    margin-bottom: 1rem;
                }
                a {
                    color: vars.$greenColor;
                    font-size: 1rem;
                    font-weight: 700;
                }
            }
        }
    }
    .how {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin: 0 auto;
        margin: 3rem 0;
        img {
            width: 50%;
            border-radius: vars.$borderRadius;
        }
        .info {
            width: 50%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 2rem;
            h2 {
                font-size: vars.$primaryFontSize;
                font-weight: 700;
                margin-bottom: 2rem;
                color: vars.$greenColor;
            }
            .first,
            .second,
            .third,
            .fourth {
                display: flex;
                align-items: center;
                margin-bottom: 1rem;
                i {
                    color: vars.$greenColor;
                    font-size: 1.5rem;
                    margin-right: 1rem;
                }
                p {
                    font-size: 1rem;
                    margin: 0;
                }
            }
        }
    }
}
@media screen and (max-width: vars.$mediumBreakpoint) {
    .container {
        padding: 0 1rem;
    }
    .card-container {
        flex-direction: column;
        .card {
            width: 100% !important;
        }
    }
    .how {
        flex-direction: column;
        img {
            width: 100% !important;
        }
        .info {
            width: 100% !important;
            padding: 1rem;
        }
    }
}
</style>
